export const DEFAULT_DOCUMENT_TITLE = 'Driver 360 Portal'
